import { Box, Typography } from "@mui/material";
import { C, DISPLAY_FONT } from "../../common/theme";
import { VoucherPreviewText } from "./promoText";

/** The voucher card buyers see in My vouchers and the cart's voucher sheet. */
export default function VoucherPreview({ text }: { text: VoucherPreviewText }) {
  return (
    <Box
      data-testid="voucher-preview"
      sx={{ display: "flex", bgcolor: C.paper, border: `1px solid ${C.line2}`, borderRadius: "10px", overflow: "hidden", minWidth: 0 }}
    >
      <Box
        sx={{
          width: 78,
          flexShrink: 0,
          bgcolor: C.moss,
          color: "#fff",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          gap: 0.25,
          py: 1.25,
          px: 0.5,
        }}
      >
        <Box component="span" sx={{ fontFamily: DISPLAY_FONT, fontWeight: 800, fontSize: text.stub.length > 5 ? 17 : 22, lineHeight: 1.1 }}>
          {text.stub}
        </Box>
        <Box component="span" sx={{ fontSize: 10, fontWeight: 700, letterSpacing: "0.08em" }}>
          {text.stubSmall}
        </Box>
      </Box>
      <Box sx={{ px: 1.5, py: 1.25, display: "flex", flexDirection: "column", gap: 0.25, minWidth: 0, fontSize: 13 }}>
        <Typography component="b" sx={{ fontWeight: 700, fontSize: 13.5, overflowWrap: "anywhere" }}>
          {text.title}
        </Typography>
        {text.lines.map((line) => (
          <Box component="span" key={line} sx={{ color: C.ink2 }}>
            {line}
          </Box>
        ))}
        <Box component="span" sx={{ color: C.coralText, fontWeight: 600 }}>
          {text.expiry}
        </Box>
      </Box>
    </Box>
  );
}
